
import React, { useEffect } from "react";
import "./header.css";

function scrollfunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    document.querySelector(".header").style.padding = "10px 10px";
    //document.querySelector(".header").style.height = "20px";
    document.querySelector(".header h1").style.fontSize = "15px";
    document.querySelector(".header-right").style.fontSize = "10px";
    //effacer si scroll down
    document.querySelector(".header-right").style.display = "none";

  } else if (document.body.scrollTop < 50 || document.documentElement.scrollTop < 50) {
    document.querySelector(".header").style.padding = "10px 10px";
    document.querySelector(".header h1").style.fontSize = "30px";
    document.querySelector(".header-right").style.fontSize = "20px";
    document.querySelector(".header-right").style.display = "flex";
    
  }
}
const Header = () => {
  useEffect(() => {
    window.onscroll = function() {
      scrollfunction();
    };
  }, []);

  
  return (
    <>
    <div className="header">
      <h1>Programme Physio</h1>

      <header className="header-right">
        <nav>
          <ul style={{ listStyleType: "none" }} className="nav"> 
            <li>
              <a href="#about">A propos</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </nav>
      </header>
    </div>
    </>
  );
};

export default Header;
